import axios from "infra/http";
import { useMutation } from "react-query";
import { showError, showSuccess } from "infra/helpers/alerta";
import error from "core/resources/firebase/error";
import { queryClient } from "infra/packages/react-query";

export interface RejeitarSolicitacao {
  id: string;
  statusMotivo?: string;
}

function useRejeitarSolicitacao() {
  return useMutation(
    (payload: RejeitarSolicitacao) => {
      return axios.post(
        `/v1/solicitacao-cadastro/${payload.id}/rejeitar`,
        payload
      );
    },
    {
      onError(err: any) {
        showError(error[(err as any).code]);
      },
      onSuccess(_, payload) {
        showSuccess("Solicitação rejeitada com sucesso!");

        queryClient.setQueryData(
          ["/solicitacao-cadastro", payload.id],
          (data: any) => {
            return {
              ...data,
              status: "rejeitado",
              statusMotivo: payload.statusMotivo,
            };
          }
        );
      },
    }
  );
}

export default useRejeitarSolicitacao;
